export default {

    displayOopsBanner: ({commit}) => { 
        commit("setProductUnavailable", true)
    },

}